import React from 'react';
import {
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';
import { SwitchColor, SwitchSize } from '../../../config';

export interface SwitchProps extends Omit<MuiSwitchProps, 'size' | 'color'> {
  size?: SwitchSize | MuiSwitchProps['size'];
  color?: SwitchColor | MuiSwitchProps['color'];
}

export const Switch: React.FC<SwitchProps> = ({ size, color, ...props }) => {
  return <MuiSwitch size={size} color={color} {...props} />;
};
